import React from "react";

type TextLinkProps = {
  url: string;
  text: string;
};

type BaseLinkProps = {
  url: string;
  text: string;
  isExternal: boolean;
};

/**
 * Intern baselenke. Ikke eksponer ut i pakken.
 */
export function BaseLink(props: BaseLinkProps) {
  const { url, text, isExternal } = props;

  return (
    <a className="svv-link" href={url} {...(isExternal && { rel: "noreferrer", target: "_blank" })}>
      {text}
    </a>
  );
}

BaseLink.displayName = "BaseLink";

export function SVVTextLink(props: TextLinkProps) {
  const { url, text } = props;
  return <BaseLink url={url} text={text} isExternal={false} />;
}

SVVTextLink.displayName = "SVVTextLink";
